import axios from './axios.service'

const methodErp = 'api-erp-dist'
const method = 'distributors'

class DistributorsService {
  async index(queryData) {
    try {
      const response = await axios.get(`/${methodErp}`,
        {
          params: { ...queryData }
        }
      )
      return response.data
    } catch (error) {
      return error.response ? (error.response.data || error.response) : error
    }
  }

  async show(id) {
    try {
      const response = await axios.get(`/${method}/${id}`)
      return response.data
    } catch (error) {
      return error.response ? (error.response.data || error.response) : error
    }
  }

  async update(id, data) {
    try {
      const response = await axios({
        method: 'put',
        url: `/${methodErp}/${id}`,
        data
      })
      return response
    } catch (error) {
      return error.response ? (error.response.data || error.response) : error
    }
  }
}

export default new DistributorsService()